export const DEVELOPMENT_MODE = 'development';
export const PRODUCTION_MODE = 'production';
export const NODE_ENV = process.env.NODE_ENV || DEVELOPMENT_MODE;

export const API_SERVER_URL = process.env.REACT_APP_API_SERVER_URL;
export const API_URL = `${API_SERVER_URL}api/`;

export const SERVER_URL = process.env.REACT_APP_SERVER_URL;

export const WP_URL = process.env.REACT_APP_WP_URL;
export const STRIPE_PK = process.env.REACT_APP_STRIPE_PK;
export const MEETINGS_HUBSPOT = process.env.REACT_APP_MEETINGS_HUBSPOT;
export const SHARE_HSFORMS = process.env.REACT_APP_SHARE_HSFORMS;

export const privatePolicyLink = 'https://eyetelligence.ai/wp-content/uploads/2021/05/gdpr-privacy-policy-6798842318670528512.pdf'
export const termsCondition = 'https://eyetelligence.ai/wp-content/uploads/2021/05/Eyetelligence-Terms-of-Use.pdf'